import {combineReducers} from '@reduxjs/toolkit';

import {groupsTabMembersSlice} from './slices/groups-tab-members.slice';
import {groupsTabStateSlice} from './slices/groups-tab-state.slice';
import {groupsTabSlice} from './slices/groups-tab.slice';

export const groupsTabReducer = combineReducers({
    result: groupsTabSlice.reducer,
    state: groupsTabStateSlice.reducer,

    members: groupsTabMembersSlice.reducer,
});
